import { type PropsWithChildren, useState } from 'react';

import { Stack } from '@mui/material';
import { useUpdateEffect } from 'ahooks';

import { SidebarNavigation } from '@ll-platform/frontend/components/InternalDashboard/components/SidebarNavigation/SidebarNavigation';
import { DashboardLayoutContentWrapper } from '@ll-platform/frontend/components/layouts/DashboardLayout/DashboardLayoutContentWrapper';
import { NavigationBar } from '@ll-platform/frontend/components/NavigationBar';
import { activityTracker } from '@ll-platform/frontend/core/analytics/activityTracker';
import { ActivityType } from '@ll-platform/frontend/core/analytics/events';
import { useActiveUser } from '@ll-platform/frontend/core/auth/hooks/useActiveUser';
import { useUpdateUserPreferences } from '@ll-platform/frontend/core/users/async/useUsersMutations';

export const InternalDashboardLayout = ({ children }: PropsWithChildren) => {
  const { activeUser } = useActiveUser();
  const updateUserPreferencesMutation = useUpdateUserPreferences({
    meta: { supressErrorToast: true },
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    !!activeUser.preferences.isInternalDashboardSidebarOpen,
  );

  useUpdateEffect(() => {
    updateUserPreferencesMutation.mutateAsync({
      id: activeUser._id,
      preferences: {
        isInternalDashboardSidebarOpen: isSidebarOpen,
      },
    });
  }, [isSidebarOpen]);

  return (
    <>
      <NavigationBar
        onHamburgerClick={() => {
          setIsSidebarOpen((current) => {
            activityTracker.log({
              type: ActivityType.DashboardClickedHamburger,
              metadata: {
                action: current ? 'close' : 'open',
              },
            });

            return !current;
          });
        }}
      />
      <Stack
        direction="row"
        sx={{ height: '100%', minHeight: 0, position: 'relative', zIndex: 0 }}
      >
        <SidebarNavigation isOpen={isSidebarOpen} />
        <DashboardLayoutContentWrapper sx={{ py: 2 }}>
          {children}
        </DashboardLayoutContentWrapper>
      </Stack>
    </>
  );
};
